export enum CalendarDateRangeType {
  FourWeeks = 0, // four weeks from the specified date
  CurrentMonth = 1, // from the first day of the month to the last day of the specified date
  OneDay = 2, // one day from the specified date
  SevenDays = 3, // seven days from the specified date
}
